module.exports = __webpack_public_path__ + "static/img/female-bg-id.6b30eb61.png";